import http from "@/http-common";
import {SelectBoxItem} from "@/api/SelectBoxItem";
import ProvinceRequestInterface from "@/request/ProviceRequestInterface";

class ProvinceService {
    async getProvinces(): Promise<SelectBoxItem[]> {
        const queryParams: { [k: string]: string } = {};
        const url = '/checkout/ajaxAddress/getprovincelist';
        const response = await http.get<ProvinceRequestInterface[]>(url, {params: queryParams});
        return response.data.map(province => new SelectBoxItem(province.value, province.label));
    }
}

export default new ProvinceService();